export default {
  accountParametersView: {
    interviews: 'Entrevues',
    configureInterviewLimits:
      'Permet de configurer les limites, les expirations et les options de planification liées aux entrevues.',
    candidate: 'Candidat',
    configureCandidateSettings: 'Permet de configurer les paramètres liés aux candidats.',
    requisitions: 'Réquisitions',
    configureRequisitionSettings: 'Permet de configurer les paramètres liés aux réquisitions.',
    positionMining: 'Recherche de postes',
    configurePositionMiningSettings: 'Permet de configurer les paramètres de recherche de postes.',
    offer: 'Offre',
    configureOfferSettings: 'Permet de configurer les paramètres liés aux offres.',
    integrations: 'Intégrations',
    configureThirdPartyIntegrations: 'Permet de configurer les intégrations de tierces parties.',
    analytics: 'Analytique',
    configureAnalyticsSettings: "Permet de configurer les paramètres d'analytique.",
    success: 'Succès',
    accountParametersUpdatedSuccessfully: 'Les paramètres du compte ont été mis à jour avec succès.',
    error: 'Erreur',
    failedToUpdateAccountParameters: 'Échec de la mise à jour des paramètres du compte.',
    accountParameters: 'Paramètres du compte',
    manageAndConfigureAccountLevelSystemParameters:
      'Permet de gérer et de configurer les paramètres du système au niveau du compte.',
    reset: 'Réinitialiser',
    saveChanges: 'Enregistrer les modifications',
    unsavedChanges: 'Modifications non enregistrées',
    youHaveUnsavedChangesAreYouSureYouWantToLeave:
      'Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir quitter ?',
    cancel: 'Annuler',
    leave: 'Quitter',
    appyhereParameters: 'Paramètres AppyHere',
    positionOverWrittenWarning: 'Ce paramètre au niveau du compte peut être défini au niveau du poste.',
    todoList: 'Liste de tâches',
    todoListDescription: 'Configurer les paramètres de la liste de tâches.',
  },
  analyticsPagesManager: {
    engName: 'Nom en anglais',
    engURL: 'URL en anglais',
    frName: 'Nom en français',
    frURL: 'URL en français',
    actions: 'Actions',
    edit: 'Modifier',
    remove: 'Supprimer',
    analyticsPages: 'Pages analytiques',
    addPage: 'Ajouter une page',
    editAnalyticsPage: 'Modifier la page analytique',
    addNewAnalyticsPage: 'Ajouter une nouvelle page analytique',
    save: 'Enregistrer',
    cancel: 'Annuler',
  },
  analyticsPane: {
    noChangesToSave: 'Aucune modification à enregistrer',
    analytics: 'Analytique',
    analyticsDescription: 'Active la vue Analytique dans Recruiter Web.',
    todoList: 'Liste de tâches',
    todoListDescription: 'Active la liste de tâches dans Recruiter Web.',
    managementOverview: 'Vue d’ensemble',
    managementOverviewDescription: 'Active la vue d’ensemble dans Recruiter Web.',
  },
  candidatePane: {
    filterCandidateByDays: "Filtre d'activité des candidats",
    filterCandidateByDaysDescription:
      "Ce paramètre contrôle le filtrage des candidats après un nombre configurable de jours d'inactivité.",
    days: 'jours',
    resumeEnabled: 'CV',
    resumeEnabledDescription:
      'Lorsque ce paramètre est activé, les postes peuvent demander un CV facultatif dans le cadre du processus de présélection.',
    virtualRecruiterEnabled: 'Recruteur virtuel',
    virtualRecruiterEnabledDescription: 'Lorsque ce paramètre est activé, les postes peuvent utiliser le recruteur virtuel.',
    languageEvaluationEnabled: 'Évaluation linguistique',
    languageEvaluationEnabledDescription:
      'Lorsque ce paramètre est activé, les postes peuvent utiliser les évaluations linguistiques comme critères de sélection.',
    languageEvaluationValidityInDays: "Validité de l'évaluation linguistique",
    languageEvaluationValidityInDaysDescription:
      'Durée en jours pendant laquelle les résultats des évaluations linguistiques sont considérés comme valides.',
    maxImageLimit: "Limite maximale d'images",
    maxImageLimitDescription: "Nombre maximal d'images qu'un candidat peut télécharger pour une question de formulaire RH.",
    count: 'nombre',
    webApplyEnabled: 'WebApply',
    webApplyEnabledDescription: "Permet aux candidats de postuler via une alternative Web à l'application mobile.",
    automaticLanguageEvaluationEnabled: 'Évaluations linguistiques automatisées',
    automaticLanguageEvaluationEnabledDescription:
      "Lorsque ce paramètre est activé, les évaluations linguistiques sont automatiquement effectuées par le système selon les seuils du poste. Si un candidat échoue, tu devras l'évaluer manuellement.",
    candidateReapplicationPeriodInDays: 'Délai de réapplication',
    candidateReapplicationPeriodInDaysDescription:
      "Nombre de jours avant qu'un candidat rejeté puisse postuler à nouveau à un poste.",
    seekerInFlightDurationInHours: 'Période « en cours »',
    seekerInFlightDurationInHoursDescription:
      "Nombre d'heures pendant lesquelles un candidat est considéré comme étant « en cours » par le système.",
    hours: 'heures',
    scheduleMatchEnabled: 'Match des disponibilités',
    scheduleMatchEnabledDescription:
      "Lorsqu'activé, permet aux postes d'utiliser la disponibilité des candidats comme critère de présélection.",
    seekerMaxHoursMatchingEnabled: "Correspondance d'heures maximales",
    seekerMaxHoursMatchingEnabledDescription:
      "Lorsque ce paramètre est activé, la fonction de disponibilité de l'horaire refusera les candidats qui ont indiqué ne pas pouvoir travailler un nombre d'heures suffisant pour le poste.",
    shouldEnableAppliedPositions: 'Voir autres candidatures',
    shouldEnableAppliedPositionsDescription: 'Affiche les autres postes auxquels le candidat a postulé dans le compte.',
  },
  dialogFlowAgentsManager: {
    displayName: "Nom d'affichage",
    agentId: "ID de l'agent",
    language: 'Langue',
    location: 'Emplacement',
    timezone: 'Fuseau horaire',
    dialogflowAgents: "Agents d'IA conversationnels",
    addAgent: 'Ajouter un agent',
    editDialogflowAgent: "Modifier l'agent d'IA conversationnel",
    addNewDialogflowAgent: "Ajouter un nouvel agent d'IA conversationnel",
    defaultLanguageCode: 'Code de langue par défaut',
    timeZone: 'Fuseau horaire',
    saveChanges: 'Enregistrer les modifications',
    save: 'Enregistrer',
    cancel: 'Annuler',
    sortedDescending: 'trié par ordre décroissant',
    sortedAscending: 'trié par ordre croissant',
    unsorted: 'non trié',
  },
  fitbandConfiguration: {
    fitbandConfiguration: "Seuils de disponibilité de l'horaire",
    done: 'Terminé',
    edit: 'Modifier',
    mediumFit: 'Correspondance moyenne',
    goodFit: 'Bonne correspondance',
    poorFit: 'Mauvaise correspondance',
  },
  genericSettingsPane: {
    parameter: 'Paramètre',
    description: 'Description',
    value: 'Valeur',
    reset: 'Réinitialiser',
    save: 'Enregistrer',
    noChangesToSave: 'Aucune modification à enregistrer',
    valueBelowRecommendedMinimum:
      'La valeur est inférieure au minimum recommandé ({{min}}). Cela peut entraîner un comportement inattendu du système.',
    valueAboveRecommendedMaximum:
      'La valeur est supérieure au maximum recommandé ({{max}}). Cela peut affecter les performances du système.',
    invalidUrl: 'URL invalide',
    invalidEmailAddress: 'Adresse email invalide',
    fieldIsRequired: 'Ce champ ne peut pas être vide.',
    pleaseFixValidationErrorsBeforeSaving: "Tu dois corriger les erreurs de validation avant d'enregistrer.",
  },
  integrationsPane: {
    competencyEvaluationPassThreshold: "Seuil de réussite de l'évaluation des compétences",
    competencyEvaluationPassThresholdDescription: "Note minimale requise pour réussir l'évaluation.",
    score: 'note',
    competencyEvaluationSubDomain: "Sous-domaine de l'évaluation des compétences",
    competencyEvaluationSubDomainDescription:
      "Le sous-domaine d'URL fourni par le partenaire pour l'intégration de l'évaluation des compétences.",
    competencyEvaluationTemplateIdList: "Identifiants des modèles d'évaluation des compétences",
    competencyEvaluationTemplateIdListDescription:
      'Identifiants de modèles séparés par des virgules. Ceux-ci peuvent ensuite être configurés au niveau du poste.',
    hireFormPdfEmail: 'Destinataire du courriel pour le PDF du formulaire RH',
    hireFormPdfEmailDescription: 'Les PDF des formulaires RH seront envoyés à cette adresse courriel une fois approuvés.',
    reset: 'Réinitialiser',
    save: 'Enregistrer',
    noChangesToSave: 'Aucune modification à enregistrer',
    competencyEvaluation: 'Évaluation des compétences',
    competencyEvaluationDescription:
      "Lorsqu'activé, permet aux postes d'utiliser l'évaluation des compétences comme critère de présélection.",
    dialogFlowEnabled: 'IA conversationnelle',
    dialogFlowEnabledDescription: "Lorsque ce paramètre est activé, les postes peuvent utiliser l'IA conversationnelle.",
    fitbandTemplateEnabled: "Modèles de disponibilité de l'horaire",
    fitbandTemplateEnabledDescription:
      "Lorsque ce paramètre est activé, les postes peuvent utiliser des modèles de disponibilité de l'horaire.",
    languageEvaluationTemplateEnabled: "Modèles d'évaluation linguistique",
    languageEvaluationTemplateEnabledDescription:
      "Lorsqu'activé, permet aux postes d'utiliser des modèles d'évaluation linguistique.",
  },
  interviewsPane: {
    calendarEnabled: 'Calendrier',
    calendarEnabledDescription: "Permet aux recruteurs d'accéder à la vue Calendrier.",
    freeOnHoldInterviews: 'Annuler les autres entrevues pour les candidats ayant une offre',
    freeOnHoldInterviewsDescription:
      "Lorsque ce paramètre est activé, toutes les autres entrevues et offres des candidats sont annulées dès qu'ils acceptent une offre.",
    interviewRequestExpiryDays: "Expiration de la demande d'entrevue",
    interviewRequestExpiryDaysDescription:
      "Annule automatiquement les demandes d'entrevue en attente une fois qu'elles ont dépassé le seuil de jours configurés.",
    appointmentHoldThresholdInDays: 'Seuil de mise en attente des entrevues',
    appointmentHoldThresholdInDaysDescription:
      "Une fois qu'un candidat a accepté une entrevue, il ne peut pas recevoir d'autres demandes d'entrevue pendant le nombre de jours configurés.",
    maxLimitInterviews: "Nombre maximal d'entrevues simultanées par poste",
    maxLimitInterviewsDescription:
      "Ce paramètre contrôle le nombre d'entrevues réservées qu'un seul poste peut avoir à la fois. Une fois la limite atteinte, aucune demande d'entrevue supplémentaire pour ce poste ne sera envoyée tant que le nombre d'entrevues simultanées ne sera pas inférieur au seuil.",
    adhocInterviewEnabled: 'Entrevues sur demande',
    adhocInterviewEnabledDescription: "Permet aux utilisateurs d'envoyer des demandes d'entrevue pour des moments précis.",
    isShiftIntersectable: 'Quarts de travail intersectables',
    isShiftIntersectableDescription: "Permet d'avoir plusieurs quarts de travail en une seule journée.",
    count: 'compte',
  },
  offerPane: {
    startDateWindow: 'Premier jour de la plage de disponibilité',
    startDateWindowDescription:
      'Lorsque les candidats acceptent une offre, ce paramètre régit le délai pendant lequel ils peuvent configurer leur premier jour de disponibilité.',
    offerAcceptancePeriod: "Période d'acceptation de l'offre",
    offerAcceptancePeriodDescription:
      'Toute offre en attente pendant une période plus longue que celle-ci sera automatiquement révoquée.',
    candidateReofferEnabled: 'Nouvelle offre à un candidat',
    candidateReofferEnabledDescription: "Permet aux candidats de recevoir de nouvelles offres alors qu'ils en ont déjà reçu une.",
    offerConditionsEnabled: "Conditions de l'offre",
    offerConditionsEnabledDescription:
      "Permet d'ajouter des conditions supplémentaires aux offres d'emploi, à la fois dans le poste et au moment de l'offre. Ces conditions doivent être acceptées par le candidat pour continuer.",
    days: 'jours',
  },
  positionMiningPane: {
    positionMiningEnabled: 'Recherche de postes',
    positionMiningEnabledDescription:
      "Lorsque ce paramètre est activé, le système recherche des correspondances plus optimales pour un candidat dans d'autres emplacements proches avec des postes ouverts.",
    positionMiningRadius: 'Rayon de recherche de postes',
    positionMiningRadiusDescription: 'Détermine la distance à laquelle le système cherchera des postes admissibles.',
    group: 'Groupe',
    inputRadius: 'Rayon',
    enablePositionMiningToSet: 'Active la recherche de postes pour définir le rayon.',
    km: 'KM',
    miles: 'Miles',
  },
  requisitionPane: {
    requisitionWebhookURL: 'URL du Webhook de réquisition',
    requisitionWebhookURLDescription:
      "Endroit où AppyHere enverra les mises à jour de statut de réquisition lorsqu'elles se produisent.",
    requisitionActiveThresholdDays: 'Date de début de recrutement de la réquisition',
    requisitionActiveThresholdDaysDescription:
      "Le système ne commencera à contacter les candidats que si la date d'entrée en vigueur d'une réquisition est plus proche de la date actuelle que le nombre de jours configuré pour ce paramètre.",
    days: 'jours',
    requisitionWebhookRetryCount: 'Nombre de tentatives pour le Webhook de réquisition',
    requisitionWebhookRetryCountDescription:
      "Nombre de fois qu'une mise à jour de statut réessaiera d'envoyer au webhook spécifié après une erreur.",
    retries: 'tentatives',
    hireFormEnabled: 'Formulaire RH',
    hireFormEnabledDescription:
      "Lorsqu'activé, les postes auront désormais des formulaires RH dans leur processus d’intégration avant l’embauche du candidat.",
    hireFormTemplateEnabled: 'Modèles de formulaires RH',
    hireFormTemplateEnabledDescription: 'Permet la création de modèles de formulaires RH à assigner aux postes.',
    positionSalaryCeilingValidation: 'Autoriser les dérogations au plafond salarial',
    positionSalaryCeilingValidationDescription: `Autoriser les dérogations au plafond salarial Permettre l'enregistrement des demandes d'embauche même si le salaire dépasse la fourchette salariale maximale du poste`,
    deactivateSalaryValidationModal: {
      title: 'Autoriser le dépassement du plafond salarial ?',
      body: `En acceptant ces conditions, vous reconnaissez assumer l'entière responsabilité de veiller à ce que les offres salariales restent conformes à la politique de l'entreprise et à la législation locale du travail.`,
      cancelBtn: 'Annuler',
      allowBtn: 'Autoriser',
    },
  },
  todoPane: {
    hireForm: {
      title: "Formulaire d'embauche",
      requested12HoursAgo: {
        title: 'Demandé il y a 12 heures',
        description:
          "Lorsque cette option est activée, le tableau de bord des tâches affichera les demandes de formulaire d'embauche datant d'il y a 12 heures",
      },
      requested24HoursAgo: {
        title: 'Demandé il y a 24 heures',
        description:
          "Lorsque cette option est activée, le tableau de bord des tâches affichera les demandes de formulaire d'embauche datant d'il y a 24 heures",
      },
      requested48HoursAgo: {
        title: 'Demandé il y a 48 heures',
        description:
          "Lorsque cette option est activée, le tableau de bord des tâches affichera les demandes de formulaire d'embauche datant d'il y a 48 heures",
      },
      requested72HoursAgo: {
        title: 'Demandé il y a 72 heures',
        description:
          "Lorsque cette option est activée, le tableau de bord des tâches affichera les demandes de formulaire d'embauche datant d'il y a 72 heures",
      },
      resubmission12HoursAgo: {
        title: 'Resoumission il y a 12 heures',
        description:
          "Lorsque cette option est activée, le tableau de bord des tâches affichera les resoumissions de formulaire d'embauche datant d'il y a 12 heures",
      },
      resubmission24HoursAgo: {
        title: 'Resoumission il y a 24 heures',
        description:
          "Lorsque cette option est activée, le tableau de bord des tâches affichera les resoumissions de formulaire d'embauche datant d'il y a 24 heures",
      },
      resubmission48HoursAgo: {
        title: 'Resoumission il y a 48 heures',
        description:
          "Lorsque cette option est activée, le tableau de bord des tâches affichera les resoumissions de formulaire d'embauche datant d'il y a 48 heures",
      },
      resubmission72HoursAgo: {
        title: 'Resoumission il y a 72 heures',
        description:
          "Lorsque cette option est activée, le tableau de bord des tâches affichera les resoumissions de formulaire d'embauche datant d'il y a 72 heures",
      },
    },
    offerMade: {
      title: 'Offre faite',
      twelveHoursAgo: {
        title: 'Il y a 12 heures',
        description:
          "Lorsque cette option est activée, le tableau de bord des tâches affichera les offres faites datant d'il y a 12 heures",
      },
      twentyFourHoursAgo: {
        title: 'Il y a 24 heures',
        description:
          "Lorsque cette option est activée, le tableau de bord des tâches affichera les offres faites datant d'il y a 24 heures",
      },
      thirtySixHoursAgo: {
        title: 'Il y a 36 heures',
        description:
          "Lorsque cette option est activée, le tableau de bord des tâches affichera les offres faites datant d'il y a 36 heures",
      },
      fortyEightHoursAgo: {
        title: 'Il y a 48 heures',
        description:
          "Lorsque cette option est activée, le tableau de bord des tâches affichera les offres faites datant d'il y a 48 heures",
      },
    },
    offerRejected: {
      title: 'Offre refusée',
      twelveHoursAgo: {
        title: 'Il y a 12 heures',
        description:
          "Lorsque cette option est activée, le tableau de bord des tâches affichera les offres refusées datant d'il y a 12 heures",
      },
      twentyFourHoursAgo: {
        title: 'Il y a 24 heures',
        description:
          "Lorsque cette option est activée, le tableau de bord des tâches affichera les offres refusées datant d'il y a 24 heures",
      },
      thirtySixHoursAgo: {
        title: 'Il y a 36 heures',
        description:
          "Lorsque cette option est activée, le tableau de bord des tâches affichera les offres refusées datant d'il y a 36 heures",
      },
      fortyEightHoursAgo: {
        title: 'Il y a 48 heures',
        description:
          "Lorsque cette option est activée, le tableau de bord des tâches affichera les offres refusées datant d'il y a 48 heures",
      },
    },
    offerExpired: {
      title: 'Offre expirée',
      twelveHoursAgo: {
        title: 'Il y a 12 heures',
        description:
          "Lorsque cette option est activée, le tableau de bord des tâches affichera les offres expirées datant d'il y a 12 heures",
      },
      twentyFourHoursAgo: {
        title: 'Il y a 24 heures',
        description:
          "Lorsque cette option est activée, le tableau de bord des tâches affichera les offres expirées datant d'il y a 24 heures",
      },
      thirtySixHoursAgo: {
        title: 'Il y a 36 heures',
        description:
          "Lorsque cette option est activée, le tableau de bord des tâches affichera les offres expirées datant d'il y a 36 heures",
      },
      fortyEightHoursAgo: {
        title: 'Il y a 48 heures',
        description:
          "Lorsque cette option est activée, le tableau de bord des tâches affichera les offres expirées datant d'il y a 48 heures",
      },
    },
  },
};
